import { useState } from 'react';

import featuredIcon from '../../../../assets/icons/content-block/featured-icon.svg';

interface ContentBlockCardProps {
    title?: string;
    description?: string;
    buttonLabel?: string;
    linkUrl?: string;
}

const ContentBlockCard = ({ title, description, buttonLabel }: ContentBlockCardProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="flex flex-col items-start p-0 mb-[40px]">
            <img src={featuredIcon} alt="Featured item" className="mb-[20px]" />

            <h3
                className="text-xl font-semibold leading-tight mb-[8px] tracking-[0px] text-[#030407]"
            >
                {title}
            </h3>

            <div
                className={`mb-[20px] transition-[max-height] duration-100 ease-in-out overflow-hidden ${
                    isExpanded ? 'max-h-[1000px]' : 'max-h-[72px]'
                }`}
            >
                <p
                    className={`text-base font-normal leading-normal break-words tracking-[0px] ${
                        isExpanded ? 'line-clamp-none' : 'line-clamp-3'
                    } text-[#667085]`}
                >
                    {description}
                </p>
            </div>

            <button
                onClick={toggleExpand}
                className="font-semibold no-underline cursor-pointer bg-transparent border-none p-0 flex items-center gap-2 text-[#030407]"
            >
                <span>{isExpanded ? 'Show less' : buttonLabel || 'Learn More'}</span>
            </button>
        </div>
    );
};

export default ContentBlockCard;
